"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSuccessfulKeycloakProcess = void 0;
const ocm_object_1 = require("@ocm/services/ocm-object");
const services_constants_1 = require("@ocm/services/services.constants");
const ocm_mercurius_messenger_1 = __importDefault(require("ocm_mercurius_messenger"));
const messageI18n = new Map([
    ["de", { newPasswordHeadline: "Neues Passwort", newPasswordMessage: "erfolgreich vergeben" }],
    ["en", { newPasswordHeadline: "New Password", newPasswordMessage: "has been set" }],
]);
const KC_ACTION_STATUS = "kc_action_status";
function handleSuccessfulKeycloakProcess() {
    var _a, _b;
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const usedLanguage = ocm_object_1.language === "de" ? "de" : "en";
    const actions = [
        {
            actionStatusValue: "success_password_forgotten",
            eventAction: "PasswordForgotten",
            banner: {
                headline: (_a = messageI18n.get(usedLanguage)) === null || _a === void 0 ? void 0 : _a.newPasswordHeadline,
                message: (_b = messageI18n.get(usedLanguage)) === null || _b === void 0 ? void 0 : _b.newPasswordMessage,
            },
        },
    ];
    actions.forEach(({ actionStatusValue, banner }) => {
        if (urlParams.get(KC_ACTION_STATUS) === actionStatusValue) {
            if (banner)
                showBanner(banner);
            removeQueryParameterFromUrl(urlParams);
        }
    });
}
exports.handleSuccessfulKeycloakProcess = handleSuccessfulKeycloakProcess;
function showBanner(banner) {
    ocm_mercurius_messenger_1.default.publish(services_constants_1.messengerPublicationTypes.ADD_BANNER, {
        type: "success",
        headline: banner.headline,
        message: banner.message,
        hideBannerFocus: true,
    });
}
function removeQueryParameterFromUrl(urlParams) {
    const updatedQuery = new URLSearchParams(urlParams);
    updatedQuery.delete(KC_ACTION_STATUS);
    const newUrl = updatedQuery.toString()
        ? `${window.location.pathname}?${updatedQuery.toString()}`
        : window.location.pathname;
    history.replaceState(null, "", newUrl);
}
